"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const getFrequencyLimitCopy_1 = require("../../../utils/getFrequencyLimitCopy");
const MobilePopover_1 = require("../../components/MobilePopover");
class LimitSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        if (props.type === 'add') {
            this.state = {
                selectorIsClosing: false,
                selectorView: '',
                count: 1,
                unit: 'd',
                value: 1,
            };
        }
        else {
            const { count, interval: { unit, value }, } = props.limits[props.id];
            this.state = {
                selectorIsClosing: false,
                selectorView: '',
                count: count,
                unit: unit,
                value: value,
            };
        }
        this.closePopoverModal = this.closePopoverModal.bind(this);
        this.getNavBarProps = this.getNavBarProps.bind(this);
        this.renderAddButton = this.renderAddButton.bind(this);
        this.setState = this.setState.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.limits !== this.props.limits) {
            if (this.props.type === 'add') {
                this.setState({
                    count: 1,
                    selectorView: '',
                    unit: 'd',
                    value: 1,
                });
            }
            else {
                const { count, interval: { unit, value }, } = this.props.limits[this.props.id];
                this.setState({
                    count: count,
                    selectorView: '',
                    unit: unit,
                    value: value,
                });
            }
        }
    }
    resetLimit() {
        const { type, limits, id } = this.props;
        if (type === 'add') {
            this.setState({
                count: 1,
                selectorView: '',
                unit: 'd',
                value: 1,
            });
        }
        else {
            const { count, interval: { unit, value }, } = limits[id];
            this.setState({
                count: count,
                selectorView: '',
                unit: unit,
                value: value,
            });
        }
    }
    closePopoverModal() {
        const { device, closePopoverModalForm, updateActivePopover } = this.props;
        if (device === 'Mobile') {
            closePopoverModalForm();
            setTimeout(() => {
                updateActivePopover('');
            }, 500);
            this.resetLimit();
            return;
        }
        updateActivePopover('');
        this.resetLimit();
    }
    getRowOnClick() {
        const { type, id, activePopover, updateActivePopover, device } = this.props;
        if (activePopover === `limit-selector-${type}-popover-${id}` && device !== 'Mobile') {
            updateActivePopover('');
        }
        else {
            updateActivePopover(`limit-selector-${type}-popover-${id}`);
        }
    }
    getNavBarProps() {
        const { limits, device, updateFrequencyLimits, type, id } = this.props;
        const { count, selectorView, unit, value } = this.state;
        if (selectorView === '') {
            return {
                buttonLeft: 'Cancel',
                buttonLeftCallback: this.closePopoverModal,
                buttonRight: 'Add',
                buttonRightCallback: () => {
                    if (type === 'edit') {
                        let tempAutomatedLimits = [...limits];
                        tempAutomatedLimits[id] = {
                            count,
                            interval: { value, unit },
                        };
                        updateFrequencyLimits(tempAutomatedLimits);
                    }
                    else {
                        updateFrequencyLimits(limits.concat({
                            count,
                            interval: { unit, value },
                        }));
                    }
                    this.closePopoverModal();
                },
            };
        }
        const getLeftElement = () => (React.createElement("div", { style: {
                display: 'flex',
                marginLeft: device === 'Mobile' ? 16 : 8,
            }, onClick: () => this.setState({ selectorIsClosing: true }, () => setTimeout(() => this.setState({
                selectorIsClosing: false,
                selectorView: '',
            }), 148)) },
            React.createElement(src_1.ChevronLeftIcon, { fill: "#000" }),
            React.createElement(src_1.Button, { text: "Back", type: "disabled", style: {
                    innerStyle: {
                        fontSize: 17,
                        padding: 0,
                        color: src_1.steel,
                    },
                    outerStyle: {
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                    },
                } })));
        return {
            buttonRight: '',
            customLeftElem: getLeftElement(),
            title: selectorView === 'count' ? 'No more than...' : selectorView === 'value' ? 'Every' : '',
        };
    }
    renderAddButton() {
        const { device } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    height: 24,
                    width: 4,
                    background: src_1.quartz,
                    marginLeft: 24,
                } }),
            React.createElement("div", { style: {
                    width: 148,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement("div", { style: {
                        width: 24,
                        height: 24,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: src_1.turquoise,
                        marginRight: 8,
                        marginLeft: 14,
                    } },
                    React.createElement(src_1.PlusIcon, { fill: src_1.white })),
                React.createElement(src_1.Button, { text: "Add Limit", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, onClick: device !== 'Desktop' ? () => this.getRowOnClick() : undefined, type: "regular" }))));
    }
    renderSelector() {
        const { device } = this.props;
        const { count, selectorIsClosing, selectorView, unit, value } = this.state;
        const style = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: device === 'Mobile' ? '100%' : 352,
            height: device === 'Mobile' ? '100%' : 216,
            background: 'white',
        };
        switch (selectorView) {
            case 'count':
                return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { animation: `${selectorView === 'count' && !selectorIsClosing ? 'ltr' : 'rtl'} 150ms ease-in-out` }) },
                    React.createElement(src_1.SelectableList, { device: device }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => (React.createElement("div", { key: key, style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px 0',
                        }, onClick: () => this.setState({
                            count: key,
                            selectorIsClosing: true,
                        }, () => setTimeout(() => this.setState({
                            selectorIsClosing: false,
                            selectorView: '',
                        }), 148)) },
                        React.createElement(src_1.Text, { size: "medium", text: `${key} time${key > 1 ? 's' : ''}` }),
                        React.createElement(src_1.RadioButton, { selected: key === count, style: {
                                outerStyle: {
                                    height: 18,
                                    width: 18,
                                },
                            } })))))));
            case 'value':
                return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { animation: `${selectorView === 'value' && !selectorIsClosing ? 'ltr' : 'rtl'} 150ms ease-in-out` }) },
                    React.createElement(src_1.SelectableList, { device: device }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => (React.createElement("div", { key: key, style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px 0',
                        }, onClick: () => this.setState({
                            selectorIsClosing: true,
                            value: key,
                        }, () => setTimeout(() => this.setState({
                            selectorIsClosing: false,
                            selectorView: '',
                        }), 148)) },
                        React.createElement(src_1.Text, { size: "medium", text: key.toString() }),
                        React.createElement(src_1.RadioButton, { selected: key === value, style: {
                                outerStyle: {
                                    height: 18,
                                    width: 18,
                                },
                            } })))))));
            case 'unit':
                return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { animation: `${selectorView === 'unit' && !selectorIsClosing ? 'ltr' : 'rtl'} 150ms ease-in-out` }) },
                    React.createElement(src_1.SelectableList, { device: device }, ['Days', 'Hours', 'Minutes'].map((key) => (React.createElement("div", { key: key, style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px 0',
                        }, onClick: () => this.setState({
                            selectorIsClosing: true,
                            unit: key.slice(0, 1).toLowerCase(),
                        }, () => setTimeout(() => this.setState({
                            selectorIsClosing: false,
                            selectorView: '',
                        }), 148)) },
                        React.createElement(src_1.Text, { size: "medium", text: key }),
                        React.createElement(src_1.RadioButton, { selected: key.slice(0, 1).toLowerCase() === unit, style: {
                                outerStyle: {
                                    height: 18,
                                    width: 18,
                                },
                            } })))))));
            default:
                return React.createElement("div", null);
        }
    }
    renderSelectorView() {
        const { device } = this.props;
        const { count, unit, value } = this.state;
        const elementStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: device === 'Mobile' ? '24px 0' : '16px 0',
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(src_1.SelectableList, { device: device },
                React.createElement("div", { key: 1, style: elementStyle, onClick: () => this.setState({ selectorView: 'count' }) },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        } },
                        React.createElement(src_1.Text, { label: true, size: "small", text: "Not more than...", textStyle: { color: src_1.steel } }),
                        React.createElement(src_1.Text, { size: "medium", text: count > 1 ? `${count} times` : 'Once' })),
                    React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium })),
                React.createElement("div", { key: 2, onClick: () => this.setState({ selectorView: 'value' }), style: elementStyle },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        } },
                        React.createElement(src_1.Text, { label: true, size: "small", text: "Every", textStyle: { color: src_1.steel } }),
                        React.createElement(src_1.Text, { size: "medium", text: value.toString() })),
                    React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium })),
                React.createElement("div", { key: 3, onClick: () => this.setState({ selectorView: 'unit' }), style: elementStyle },
                    React.createElement(src_1.Text, { size: "medium", text: unit === 'd' ? 'Days' : unit === 'h' ? 'Hours' : 'Minutes' }),
                    React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium }))),
            this.renderSelector()));
    }
    render() {
        const { activePopover, device, isPopoverModalFormOpen, shouldShowAddButton, type, id, limits } = this.props;
        return device !== 'Mobile' ? (React.createElement("div", null,
            React.createElement(src_1.PopoverContainer, { id: `limit-selector-${type}-popover-${id}`, popoverProps: {
                    placement: 'right',
                    device: device,
                    navBarProperties: this.getNavBarProps(),
                    overlayClickHandler: () => this.resetLimit(),
                }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: () => this.getRowOnClick(), showPopover: activePopover === `limit-selector-${type}-popover-${id}` },
                shouldShowAddButton && type === 'add'
                    ? this.renderAddButton()
                    : type === 'edit' && React.createElement(src_1.Text, { size: "medium", text: getFrequencyLimitCopy_1.default(limits[id]) }),
                React.createElement("div", { style: {
                        height: 216,
                        width: 352,
                        overflowY: 'scroll',
                        position: 'relative',
                    } }, this.renderSelectorView())))) : (React.createElement("div", { onClick: () => this.getRowOnClick() },
            shouldShowAddButton && type === 'add'
                ? this.renderAddButton()
                : type === 'edit' && React.createElement(src_1.Text, { size: "medium", text: getFrequencyLimitCopy_1.default(limits[id]) }),
            activePopover === `limit-selector-${type}-popover-${id}` &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: this.getNavBarProps() },
                    React.createElement(src_1.Text, { text: "Add Limit", size: "h1", textStyle: { margin: 24, marginBottom: 8 } }),
                    React.createElement("div", { style: {
                            height: 'calc(100% - 128px)',
                            width: '100%',
                            overflow: 'scroll',
                            position: 'relative',
                        } }, this.renderSelectorView())), document.getElementById('mainModalLeft'))));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    limits: reducers_1.getEditableCampaignFrequencyLimits(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    shouldShowAddButton: reducers_1.getAutomatedLimitType(state) === 'No more than...',
});
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (popover) => dispatch(actions_1.updateActivePopover(popover)),
    updateFrequencyLimits: (limits) => dispatch(actions_1.updateFrequencyLimits(limits)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LimitSelector);
